import type { ReactNode } from 'react';

export const symbol_man_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M420-100v-250h-50q-12.75 0-21.37-8.63Q340-367.25 340-380v-223q0-24.75 17.63-42.38Q375.25-663 400-663h160q24.75 0 42.38 17.62Q620-627.75 620-603v223q0 12.75-8.62 21.37Q602.75-350 590-350h-50v250q0 12.75-8.65 21.37Q522.71-70 509.93-70h-60.15Q437-70 428.5-78.63 420-87.25 420-100Zm39-635-41-41q-9-9-9-21t9-21l41-41q9-9 21-9t21 9l41 41q9 9 9 21t-9 21l-41 41q-9 9-21 9t-21-9Z"
		/>
	</svg>
);
